import React from 'react';
import { helpeResource } from './constants';
import { Link } from 'react-router-dom';

const HelpeResource = () => {
  return (
    <div className="help-resources mb-3">
      <h4 className="mb-3">Help Resources</h4>
      <div className="row help_resource_container">
        {helpeResource.map((value, index) => {
          return (
            <div key={index} className="col-lg-3">
              <Link target={value.target} to={`${value.navigate}`} className="d-block">
                <div
                  className="d-flex align-items-center"
                  style={{ background: `${value.background}` }}>
                  <span
                    className="me-3 d-flex justify-content-center align-items-center"
                    style={{ color: value.iconColor }}>
                    {value.icon}
                  </span>
                  {value.title}
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HelpeResource;
